var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11,
    viewBox: "0 0 16 11",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 10.434783,
    rx: 1,
    width: 14.608696,
    x: 1.391304
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e54252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c63442"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5cbe6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ea55b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.391304 0h14.608696v6.956522h-14.608696z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.391304 6.956522h14.608696v3.478261h-14.608696z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.47826087 8.86956522v1.56521738h-2.08695652v-10.4347826h2.08695652v1.56521739l-.34782609.52173913.34782609.52173913v1.04347826l-.34782609.52173913.34782609.52173913v1.04347826l-.34782609.52173914.34782609.52173913v1.04347826l-.34782609.52173913z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.34782609 2.08695652.69565217-1.04347826.69565217 1.04347826-.69565217 1.04347826zm0 2.08695652.69565217-1.04347826.69565217 1.04347826-.69565217 1.04347826zm0 2.08695653.69565217-1.04347827.69565217 1.04347827-.69565217 1.04347826zm0 2.08695652.69565217-1.04347826.69565217 1.04347826-.69565217 1.04347826z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.73913043 1.04347826.69565218-1.04347826.69565217 1.04347826-.69565217 1.04347826zm0 2.08695652.69565218-1.04347826.69565217 1.04347826-.69565217 1.04347826zm0 2.08695652.69565218-1.04347826.69565217 1.04347826-.69565217 1.04347827zm0 2.08695653.69565218-1.04347826.69565217 1.04347826-.69565217 1.04347826zm0 2.08695652.69565218-1.04347826.69565217 1.04347826-.69565217 1.04347825z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBy);
export default __webpack_public_path__ + "static/media/BY.9f7b4c0bc1903a961a3e12779f2e2c78.svg";
export { ForwardRef as ReactComponent };